import appConstant from 'constants/app';
import { broadCastService } from 'services/notifications/BroadCastService';
import { hubConnection } from 'signalr-no-jquery';

export default class SignalR {
    connection = hubConnection(`${process.env.REACT_APP_NOTIFICATION_URL}`, {
        // useDefaultPath: true,
        // transport: ["serverSentEvents", "longPolling"],
        // qs: { "user_id": authService.getUserId }
    });

    hubProxy = this.connection.createHubProxy('defaultHub');

    constructor(companyCode) {
        this.registerEvents(companyCode)
    }

    static rservice1 = null;
    static rservice2 = null;

    static getInstance1 = (companyCode) => {
        if (SignalR.rservice1 === null) {
            SignalR.rservice1 = new SignalR(companyCode);
        }

        return this.rservice1;
    }

    static getInstance2 = (companyCode) => {
        if (SignalR.rservice2 === null) {
            SignalR.rservice2 = new SignalR(companyCode);
        }

        return this.rservice2;
    }

    static setInstanceNull = () => {
        SignalR.rservice1 = null;
        SignalR.rservice2 = null;
    }

    start = (user_id) => {
        this.connection.qs = { "user_id": user_id };
        //let self = this;
        this.connection.start({})
            .done(function () { 
               // console.log('Now connected, connection ID=' + self.connection.id); 
            })
            .fail(function () { 
             //   console.log('Could not connect');
             });
    }

    stop = () => {
        //console.log('Connect stoted');
        this.connection.stop(true);
    }

    registerEvents = (companyCode) => {
        appConstant.signalREvents.forEach(event => {
            this.hubProxy.on(event,(data)=>{
                broadCastService.broadCast(event,{...data,companyCode});
            });  
        });  
    }
}

